module.exports = __webpack_public_path__ + "img/img_yiwen.8fb34b3d.png";